import React from "react";
import EditSvg from "SvgIcons/EditSvg";
import QuoteSvg from "SvgIcons/QuoteSvg";
import { Grid, IconButton } from "@mui/material";

type WFRQuoteNoteButtonContainerProps = {
    toggleNote: () => void;
    showNote: boolean;
    toggleQuote: () => void;
    showQuote: boolean;
    toggleAnswerAlert: () => void;
    flagActive: boolean;
    interactionType?: number;
    restrictMedia?: boolean;
    isDisabled?: boolean;
    hideNoteButton?: boolean;
};

interface QuoteNoteButtonProps {
    onClick: () => void;
    isActive?: boolean;
    IconComponent: React.ElementType;
    iconProps: object;
    iconSize: { width: string; height: string };
}

const QuoteNoteButton: React.FC<QuoteNoteButtonProps> = ({
    onClick,
    isActive,
    IconComponent,
    iconProps,
    iconSize,
}) => {
    return (
        <Grid item sx={{ textAlign: "center" }}>
            <IconButton
                onClick={onClick}
                sx={{
                    marginBottom: "0.5rem",
                    padding: "8px",
                    backgroundColor: isActive
                        ? (theme) => theme.palette.primary.main
                        : "#e6e6e6",
                    "&:hover": isActive
                        ? {
                              backgroundColor: (theme) =>
                                  theme.palette.primary[300],
                          }
                        : undefined,
                }}
                size="large"
            >
                <IconComponent
                    {...iconSize}
                    style={{
                        color: isActive ? "white" : "#1F1F1F",
                        opacity: isActive ? 1 : 0.25,
                    }}
                    {...iconProps}
                />
            </IconButton>
        </Grid>
    );
};

const WFRQuoteNoteButtonContainer: React.FC<WFRQuoteNoteButtonContainerProps> =
    ({
        toggleNote,
        showNote,
        toggleQuote,
        showQuote,
        interactionType,
        restrictMedia,
        hideNoteButton,
    }) => {
        const iconSize = { width: "20px", height: "20px" };

        return (
            <>
                {!hideNoteButton && (
                    <QuoteNoteButton
                        onClick={toggleNote}
                        isActive={showNote}
                        IconComponent={EditSvg}
                        iconProps={{
                            width: "20px",
                            height: "20px",
                        }}
                        iconSize={iconSize}
                    />
                )}
                {interactionType !== 4 && !restrictMedia && false && (
                    <QuoteNoteButton
                        onClick={toggleQuote}
                        isActive={showQuote}
                        IconComponent={QuoteSvg}
                        iconProps={{
                            width: "20px",
                            height: "20px",
                        }}
                        iconSize={iconSize}
                    />
                )}
            </>
        );
    };

export default WFRQuoteNoteButtonContainer;
